import { create } from "zustand";

export const SUBSCRIPTION_PRODUCT_NAME = "subscriptionProductName";

interface ClientSecretAndInvoiceToPay {
  clientSecret: string;
}

interface SuccessRetryPaymentListenerState {
  clientSecretAndInvoiceToPay: null | ClientSecretAndInvoiceToPay;
  setClientSecretAndInvoiceToPay: (state: ClientSecretAndInvoiceToPay) => void;

  reset: () => void;
}

const useRetryPaymentWStripeFormStore =
  create<SuccessRetryPaymentListenerState>((set) => ({
    clientSecretAndInvoiceToPay: null,
    setClientSecretAndInvoiceToPay: (clientSecretAndInvoiceToPay) =>
      set({ clientSecretAndInvoiceToPay }),

    reset: () =>
      set({
        clientSecretAndInvoiceToPay: null,
      }),
  }));

export default useRetryPaymentWStripeFormStore;
